<!-- Persoana fizica -->
<div class="g-0">
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="box-wrapper box-subsemnat">
                <div class="box-content-header box-content-header-subsemnat">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-regular fa-user"></i>
                                <span>Subsemnatul</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onSubsemnatulInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                    <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere?.beneficiar"
                                        value="beneficiar">Beneficiar</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere?.adresa_sediu"
                                        value="sediu">Sediu</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'info'">
                        <tbody>
                            <tr *ngIf="cerere.cetatean?.cui !== null">
                                <td class="text-center">
                                    <strong>Denumire</strong>
                                </td>
                                <td>
                                    {{ cerere.cetatean?.denumire }}
                                </td>
                            </tr>
                            <tr *ngIf="cerere.cetatean?.cui !== null">
                                <td class="text-center">
                                    <strong>CUI:</strong>
                                </td>
                                <td class="text-left">
                                    {{cerere.cetatean?.cui}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Nume</strong>
                                </td>
                                <td class="text-left">{{ (cerere.cetatean?.nume || cerere.cetatean?.prenume) ?
                                    (cerere.cetatean?.nume) + ' ' + (cerere.cetatean?.prenume) : 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Info CI/BI:</strong>
                                </td>
                                <td class="text-left">{{ (cerere.cetatean?.ci_serie || cerere.cetatean?.ci_numar) ?
                                    (cerere.cetatean?.ci_serie) + ' | ' + (cerere.cetatean?.ci_numar) : 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>CNP</strong>
                                </td>
                                <td class="text-left">{{ cerere.cetatean?.cnp || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Telefon</strong>
                                </td>
                                <td class="text-left">{{ cerere.cetatean?.telefon || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Email</strong>
                                </td>
                                <td class="text-left">{{ cerere.cetatean?.email || 'n/a' }}</td>
                            </tr>
                            <tr *ngIf="cerere?.cetatean?.observatii !== null && cerere?.cetatean?.observatii !== ''">
                                <td class="text-center">
                                    <strong>Observații:</strong>
                                </td>
                                <td class="text-left">
                                    {{cerere.cetatean?.observatii}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box"
                        *ngIf="selectedSubsemnatulStatus === 'adresa'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.judet_name || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Oraș/Municipiu/Comună/Sat</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.oras || 'n/a' }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.sector !== null">
                                <td class="text-center">
                                    <strong>Sector</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.sector }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.strada || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.numar || 'n/a' }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.bloc !== null">
                                <td class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.bloc }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.scara !== null">
                                <td class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.scara }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.etaj !== null">
                                <td class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.etaj }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.apartament !== null">
                                <td class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_domiciliu?.apartament }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_domiciliu?.observatii !== null">
                                <td class="text-center">
                                    <strong>Observații:</strong>
                                </td>
                                <td class="text-left">
                                    {{cerere.adresa_domiciliu?.observatii }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box"
                        *ngIf="selectedSubsemnatulStatus === 'sediu'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.judet_name || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Oraș/Municipiu/Comună/Sat</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.oras || 'n/a' }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_sediu?.sector !== null">
                                <td class="text-center">
                                    <strong>Sector</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.sector }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.strada || 'n/a' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.numar || 'n/a' }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_sediu?.bloc !== null">
                                <td class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.bloc }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_sediu?.scara !== null">
                                <td class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.scara }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_sediu?.etaj !== null">
                                <td class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.etaj }}</td>
                            </tr>
                            <tr *ngIf="cerere?.adresa_sediu?.apartament !== null">
                                <td class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">{{ cerere.adresa_sediu?.apartament }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="col d-flex justify-content-start p-2" *ngIf="selectedSubsemnatulStatus === 'beneficiar'">
                        <div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onBeneficiarInfoChange($event)" value="info">
                                <mat-button-toggle value="info">Info</mat-button-toggle>
                                <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'beneficiar' && selectedBeneficiaryInfoStatus === 'info'">
                        <tbody>
                            
                            <ng-container *ngIf="cerere?.beneficiar?.beneficiar_type === '1'">
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Nume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.nume }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Prenume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.prenume }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CNP</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.cnp_cui }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CI Serie</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.ci_serie }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CI Număr</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.ci_numar }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CI Emitent</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.ci_emitent }}</td>
                                </tr>
                            </ng-container>
                            
                            <ng-container *ngIf="cerere?.beneficiar?.beneficiar_type === '2'">
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Denumire companie</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.denumire }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CUI/CIF</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.cnp_cui }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Registrul comerțului</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.beneficiar.reg_com || 'n/a' }}</td>
                                </tr>
                            </ng-container>

                            <tr>
                                <td class="text-center">
                                    <strong>Activ</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.active == 1 ? 'Da' : 'Nu' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Creat la</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.created_at | date }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Expiră la</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.expiry_date | date }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Validat</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.validated_date ? 'Da' : 'Nu' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'beneficiar' && selectedBeneficiaryInfoStatus === 'adresa'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].judet_name }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Oraș</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].oras }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].strada }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].numar }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].bloc }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].scara }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].etaj }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">{{ cerere.beneficiar.addresses[0].apartament }}</td>
                            </tr>
                        </tbody>
                    </table> -->
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <app-informatii-aditionale [cerere]="cerere"></app-informatii-aditionale>
        </div>
    </div>
</div>
<!-- Persoana juridica -->
<!-- <div class="g-0">

    <div class="box-wrapper box-property">
        <div class="box-content-header">
            <div class="row p-1">
                <div class="col">
                    <mat-card-title>
                        <i class="fa-solid fa-clipboard-list"></i>
                        <span>Informații adiționale</span>
                    </mat-card-title>
                </div>
            </div>
        </div>
        <div class="box-content-body">

        </div>
    </div>

    <div class="row p-3">
        <div class="col">

        </div>
        <div class="col d-flex justify-content-end">
                <div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onPJInfoFilesChange($event)"
                        value="info">
                        <mat-button-toggle value="info">Info</mat-button-toggle>
                        <mat-button-toggle value="orar">Orar</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="row p-3" *ngIf="selectedPJFiles === 'info'">
                <div class="col">
                    <div>Activități CAEN</div>
                    <div class="fw-bold">{{ mockUserPJ.suplimentare.caen }}</div>
                </div>
                <div class="col">
                    <div>Observații</div>
                    <div class="fw-bold">{{ mockUserPJ.suplimentare.observatii }}</div>
                </div>
            </div>
            <div class="row p-3" *ngIf="selectedPJFiles === 'orar'">
                <div class="col">
                    <div>Test</div>
                    <div class="fw-bold">{{ mockUserPJ.orar.orar1 }}</div>
                </div>
                <div class="col">
                    <div>Observații</div>
                    <div class="fw-bold">{{ mockUserPJ.orar.orar2 }}</div>
                </div>
            </div>
    </div>

</div> -->